export type MessageType = ValueOf<typeof MESSAGE_TYPE>;

export const MESSAGE_TYPE = Object.freeze({
  TEXT: 'text',
  EMAIL: 'email',
} as const);
